import React from "react";

export default function GanttTimelineHeader(props) {

  var {
    startDate,
    endDate,
    weekWidth
  } = props;

  function getWeeksBetween(start, end) {

    var weeks = [];
    var current = new Date(start);

    // normalise to start of week (Monday)
    var day = current.getDay();
    var diff = current.getDate() - day + (day === 0 ? -6 : 1);
    current.setDate(diff);

    while (current <= end) {
      weeks.push(new Date(current));
      current = new Date(current);
      current.setDate(current.getDate() + 7);
    }

    return weeks;
  }

  function formatMonth(date) {
    return date.toLocaleString("default", { month: "short", year: "numeric" });
  }

  function formatWeek(date) {
    return "W/C " + date.getDate();
  }

  var weeks = getWeeksBetween(startDate, endDate);

  // Group weeks by month
  var months = [];
  var currentMonth = null;

  weeks.forEach(function (week) {
    var monthKey = week.getFullYear() + "-" + week.getMonth();

    if (!currentMonth || currentMonth.key !== monthKey) {
      currentMonth = {
        key: monthKey,
        label: formatMonth(week),
        weeks: []
      };
      months.push(currentMonth);
    }

    currentMonth.weeks.push(week);
  });

  return (
    <div style={styles.container}>

      {/* MONTH ROW */}
      <div style={styles.monthRow}>
        {months.map(function (month) {
          return (
            <div
              key={month.key}
              style={{
                ...styles.monthCell,
                width: month.weeks.length * weekWidth
              }}
            >
              {month.label}
            </div>
          );
        })}
      </div>

      {/* WEEK ROW */}
      <div style={styles.weekRow}>
        {weeks.map(function (week, index) {
          return (
            <div
              key={index}
              style={{
                ...styles.weekCell,
                width: weekWidth
              }}
            >
              {formatWeek(week)}
            </div>
          );
        })}
      </div>

    </div>
  );
}

const styles = {

  container: {
    borderBottom: "1px solid #e6e6e6",
    background: "#fafafa"
  },

  monthRow: {
    display: "flex",
    borderBottom: "1px solid #ddd",
	background:"linear-gradient(180deg, #2F80ED 0%, #1C5FD4 100%)"
  },

  monthCell: {
    textAlign: "center",
    fontSize: "12px",
    fontWeight: 600,
    padding: "6px 0",
    borderRight: "1px solid #eee",
    color: "white"
  },

  weekRow: {
    display: "flex",
	background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)",
  },

  weekCell: {
    textAlign: "center",
    fontSize: "11px",
    padding: "4px 0",
    borderRight: "1px solid #ddd",
    color: "#666"
  }
};
